import React, { useState, useEffect } from 'react'
import './Block.css'
import DeleteIcon from '@mui/icons-material/Delete'
import UpdateIcon from '@mui/icons-material/Update'
import AddIcon from '@mui/icons-material/Add'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Sidebar from '../sidebar'
import NavLogo from '../NavLogo'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Col, Row } from 'react-bootstrap'
import { MDBDataTable } from 'mdbreact'
import { MenuItem } from '@mui/material'
import {
  BlockAddApi,
  BlockFindallApi,
  BlockUpdateApi,
  FeeTypeFindAllApi,
} from '../../ApiFile'
import MobileNavbarAdmin from '../pages/MobileNavbarAdmin'

const Block = () => {
  const [blocks, setBlocks] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const [blockName, setBlockName] = useState('')
  const [fee, setFee] = useState('')
  const [feeId, setFeeId] = useState([])
  const [room_range, setRoom_range] = useState('')
  const [discription, setDiscription] = useState('')
  const [bed_count, setBed_count] = useState('')
  const [amount, setAmount] = useState('')
  const [image, setImage] = useState(null)
  const [image1, setImage1] = useState(null)
  const [updateBlockData, setUpdateBlockData] = useState({
    id: '',
    fee: '',
    block_id: '',
    room_range: '',
    discription: '',
    bed_count: '',
    file: null,
    file1: null,
  })

  useEffect(() => {
    fetchBlocks()
    fetchFeeId()
  }, [])

  const fetchFeeId = async () => {
    try {
      const response = await fetch(FeeTypeFindAllApi)
      if (!response.ok) {
        throw new Error('Failed to fetch fee data')
      }
      const data = await response.json()
      if (data === 'NOTFOUND') {
        setFeeId([]) // Set rules to an empty array if "NOTFOUND"
      } else {
        setFeeId(data)
      }
    } catch (error) {
      // console.error('Error fetching fee data:', error);
    }
  }

  const fetchBlocks = async () => {
    try {
      const response = await fetch(BlockFindallApi)
      if (!response.ok) {
        throw new Error('Failed to fetch blocks')
      }
      const data = await response.json()
      if (data === 'NOTFOUND') {
        setBlocks([]) // Set rules to an empty array if "NOTFOUND"
      } else {
        setBlocks(data)
      }
    } catch (error) {
      // console.error('Error fetching blocks:', error);
    }
  }

  const handleCloseModal = () => {
    setShowModal(false)
    setBlockName('')
    setRoom_range('')
    setFee('')
    setBed_count('')
    setDiscription('')
    setImage(null)
    setImage1(null)
  }

  const handleShowModal = () => setShowModal(true)

  const handleAddBlock = async () => {
    let formData = new FormData()
    try {
      if (
        blockName.trim() !== '' ||
        fee.trim() !== '' ||
        room_range.trim() !== '' ||
        bed_count.trim() !== '' ||
        discription.trim() !== ''
      ) {
        formData.append('fee_id', fee)
        formData.append('block_id', blockName)
        formData.append('room_range', room_range)
        formData.append('bed_count', bed_count)
        formData.append('discription', discription)
        formData.append('file', image)
        formData.append('file1', image1)

        const response = await axios.post(BlockAddApi, formData)

        if (response.data === 'SAVED') {
          toast.success('Saved Successfully !!!!!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
          fetchBlocks()
          handleCloseModal()
        }
      }
    } catch (error) {
      console.error('Error adding block:', error)
    }
  }

  const handleUpdateModalOpen = (block) => {
    setUpdateBlockData({
      id: block.id,
      fee_name: block.fee_name,
      block_id: block.block_id,
      room_range: block.room_range,
      discription: block.discription,
      bed_count: block.bed_count,
      file: block.room_img,
      file1: block.bed_img,
    })
    setShowUpdateModal(true)
  }

  const handleUpdateModalClose = () => {
    setShowUpdateModal(false)
    setBlockName('')
    setRoom_range('')
    setFee('')
    setBed_count('')
    setDiscription('')
    setImage(null)
    setImage1(null)
  }

  const handleUpdateImageChange = (e) => {
    setUpdateBlockData({ ...updateBlockData, file: e.target.files[0] })
  }

  const handleUpdateImageChange1 = (e) => {
    setUpdateBlockData({ ...updateBlockData, file1: e.target.files[0] })
  }

  const handleUpdateBlock = async () => {
    let formData = new FormData()
    formData.append('fee_id', updateBlockData.fee_id)
    formData.append('block_id', updateBlockData.block_id)
    formData.append('room_range', updateBlockData.room_range)
    formData.append('bed_count', updateBlockData.bed_count)
    formData.append('discription', updateBlockData.discription)
    if (updateBlockData.file) {
      formData.append('file', updateBlockData.file)
    }
    if (updateBlockData.file1) {
      formData.append('file1', updateBlockData.file1)
    }

    try {
      const response = await axios.put(
        `${BlockUpdateApi}/${updateBlockData.id}`,
        formData,
      )
      if (response.data === 'NOTFOUND') {
        alert('Block not found')
      } else if (response.data == 'UPDATE') {
        toast.success('Updated Successfully !!!!!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })

        fetchBlocks()
        handleUpdateModalClose()
      } else {
        // console.error('Failed to update block');
        toast.error('Failed to update block!!!!!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        })
      }
    } catch (error) {
      // console.error('Error updating block:', error);
    }
  }

  const columns = [
    { label: 'Sr.no', field: 'srNo', sort: 'asc' },
    { label: 'Block Number', field: 'blockNumber' },
    { label: 'Fee Name', field: 'fee_name' },
    { label: 'Room Range', field: 'roomRange' },
    { label: 'Beds Per Room', field: 'bedCount' },
    { label: 'Facilities', field: 'discription' },
    { label: 'Block Image', field: 'file' },
    { label: 'Room Image', field: 'file1' },
    {
      label: 'Update',
      field: 'update',
      width: 100,
    },
  ]

  const rows = blocks.map((block, index) => ({
    srNo: index + 1,
    blockNumber: block.block_id,
    fee_name: block.fee_name,
    roomRange: block.room_range,
    bedCount: block.bed_count,
    file: block.room_img,
    file1: block.bed_img,
    discription: block.discription,
    update: (
      <button
        className="m-1"
        style={{
          color: 'rgb(0, 123, 255)',
          border: '0px',
          backgroundColor: 'transparent',
        }}
        onClick={() => handleUpdateModalOpen(block)}
      >
        <i className="fa-solid fa-pen-to-square"></i>
      </button>
    ),
  }))

  const dataTable = { columns, rows }

  const handleImageChange = (e) => {
    setImage(e.target.files[0])
  }
  const handleImageChange1 = (e) => {
    setImage1(e.target.files[0])
  }

  return (
    <>
     <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
                         {/* Sidebar on the left for desktop */}
                         <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
                           <Sidebar />
                         </div>
                   
                         {/* Main content on the right */}
                         <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
                           <NavLogo />
                 
                       <div className="d-block d-md-none">
                         <MobileNavbarAdmin />
                       </div>
        <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
          <div className='col-12 col-md-6'>
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
               Hostel Block
            </h5>
            </div>
            <div className='col-12 col-md-6 text-end'>
              <Button
              className="ms-md-4 ms-2  mb-2 mb-md-4 mt-2"
              variant="contained"
              color="primary"
              onClick={handleShowModal}
              startIcon={<AddIcon />}
            >
              Add Block
            </Button>
            </div>
          </div>

          <Row className="m-0 pt-1 px-2 mx-md-3 mb-3 rounded">
            <Col
              className="m-0 p-0 px-3 py-3 rounded shadow"
              style={{ background: 'white' }}
            >
              <div style={{ overflowY: 'auto' }}>
                <div style={{ overflowX: 'auto' }}>
                  <MDBDataTable
                    className="custom-datatable"
                    hover
                    striped
                    bordered
                    small
                    data={dataTable}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Modal
            open={showModal}
            onClose={handleCloseModal}
            style={{ overflow: 'scroll' }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                p: 4,
                width: '70%',
                boxShadow: 24,
              }}
            >
              <Typography
                variant="h4"
                component="h2"
                gutterBottom
                className="mb-md-4 mb-2"
              >
                Add Block
              </Typography>
              <Row>
                <Col ms={12} md={6}>
                  <TextField
                    label="Block Name"
                    size="small"
                    value={blockName}
                    onChange={(e) => setBlockName(e.target.value)}
                    fullWidth
                    style={{ marginBottom: '20px' }}
                  />
                </Col>
                <Col ms={12} md={6}>
                  <TextField
                    size="small"
                    select
                    label="Select Fee Name"
                    value={fee}
                    onChange={(e) => setFee(e.target.value)}
                    fullWidth
                    style={{ marginBottom: '20px' }}
                    required
                  >
                    {feeId.map((fee) => (
                      <MenuItem key={fee.fee_id} value={fee.fee_id}>
                        {fee.fee_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Col>
                <Col ms={12} md={6}>
                  <TextField
                    label="Room Range"
                    size="small"
                    value={room_range}
                    onChange={(e) => setRoom_range(e.target.value)}
                    fullWidth
                    style={{ marginBottom: '20px' }}
                  />
                </Col>
                <Col ms={12} md={6}>
                  <TextField
                    label="Bed Per Room"
                    size="small"
                    type="number"
                    value={bed_count}
                    onChange={(e) => setBed_count(e.target.value)}
                    fullWidth
                    style={{ marginBottom: '20px' }}
                  />
                </Col>
                <Col ms={12} md={6}>
                  <label>Select Block Image</label>
                  <input
                    type="file"
                    className="w-100"
                    onChange={handleImageChange}
                    style={{ marginBottom: '20px', borderRadius: '0px' }}
                  />
                </Col>
                <Col ms={12} md={6}>
                  <label>Select Room Image</label>
                  <input
                    type="file"
                    className="w-100"
                    onChange={handleImageChange1}
                    style={{ marginBottom: '20px' }}
                  />
                </Col>
                <Col ms={12} md={12}>
                  <TextField
                    label="Facilities"
                    size="small"
                    value={discription}
                    onChange={(e) => setDiscription(e.target.value)}
                    fullWidth
                    style={{ marginBottom: '20px' }}
                  />
                </Col>
              </Row>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddBlock}
                style={{ marginRight: '10px' }}
              >
                Add
              </Button>
              <Button variant="contained" onClick={handleCloseModal}>
                Cancel
              </Button>
            </Box>
          </Modal>

          <Modal
            open={showUpdateModal}
            onClose={handleUpdateModalClose}
            style={{ overflow: 'scroll' }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                p: 4,
                width: '70%',
                boxShadow: 24,
              }}
            >
              <Typography
                variant="h4"
                component="h2"
                gutterBottom
                className="mb-md-4 mb-2"
              >
                Update Block
              </Typography>
              <Row>
                <Col ms={12} md={6}>
                  <TextField
                    label="Block Name"
                    size="small"
                    value={updateBlockData.block_id}
                    onChange={(e) =>
                      setUpdateBlockData({
                        ...updateBlockData,
                        block_id: e.target.value,
                      })
                    }
                    fullWidth
                    style={{ marginBottom: '20px' }}
                  />
                </Col>
                <Col ms={12} md={6}>
                  <TextField
                    size="small"
                    select
                    label="Select Fee Name"
                    value={updateBlockData.fee_name}
                    onChange={(e) =>
                      setUpdateBlockData({
                        ...updateBlockData,
                        fee_name: e.target.value,
                      })
                    }
                    fullWidth
                    style={{ marginBottom: '20px' }}
                    required
                  >
                    {feeId.map((fee) => (
                      <MenuItem key={fee.fee_name} value={fee.fee_name}>
                        {fee.fee_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Col>
                <Col ms={12} md={6}>
                  <TextField
                    label="Room Range"
                    size="small"
                    value={updateBlockData.room_range}
                    onChange={(e) =>
                      setUpdateBlockData({
                        ...updateBlockData,
                        room_range: e.target.value,
                      })
                    }
                    fullWidth
                    style={{ marginBottom: '20px' }}
                  />
                </Col>
                <Col ms={12} md={6}>
                  <TextField
                    label="Bed Per Room"
                    size="small"
                    value={updateBlockData.bed_count}
                    onChange={(e) =>
                      setUpdateBlockData({
                        ...updateBlockData,
                        bed_count: e.target.value,
                      })
                    }
                    fullWidth
                    style={{ marginBottom: '20px' }}
                  />
                </Col>
                <Col ms={12} md={6}>
                  <label>Select Block Image</label>
                  <input
                    type="file"
                    onChange={handleUpdateImageChange}
                    className="w-100"
                    style={{ marginBottom: '20px', borderRadius: '0px' }}
                  />
                </Col>
                <Col ms={12} md={6}>
                  <label>Select Room Image</label>
                  <input
                    type="file"
                    onChange={handleUpdateImageChange1}
                    className="w-100"
                    style={{ marginBottom: '20px', borderRadius: '0px' }}
                  />
                </Col>
                <Col ms={12} md={12}>
                  <TextField
                    label="Facilities"
                    size="small"
                    value={updateBlockData.discription}
                    onChange={(e) =>
                      setUpdateBlockData({
                        ...updateBlockData,
                        discription: e.target.value,
                      })
                    }
                    fullWidth
                    style={{ marginBottom: '20px' }}
                  />
                </Col>
              </Row>
              <Button
                variant="contained"
                color="primary"
                onClick={handleUpdateBlock}
                style={{ marginRight: '10px' }}
              >
                Update
              </Button>
              <Button variant="contained" onClick={handleUpdateModalClose}>
                Cancel
              </Button>
            </Box>
          </Modal>
        </div>
      </div>
      </div>
    </>
  )
}

export default Block
